<template>
  <div id="alert">
    <transition name="slide">
      <div class="alert" v-bind:class="alert.type" v-if="alert.message">
        <div class="alertMessage" v-html="alert.message"></div>
        <button class="closeAlert" @click="closeAlert">Close</button>
      </div>
    </transition>
  </div>
</template>

<script>
import {store} from '@/store'

export default {
  name: 'Alert',
  props: ['activity'],
  data () {
    return {
      checkedProxy: false
    }
  },
  computed: {
    alert () {
      return store.state.alert
    }
  },
  methods: {
    closeAlert () {
      store.commit('setAlert', {
        message: false
      })
    }
  }
}
</script>

<style lang="scss">
  @import '../../scss/variables/variables';
  #alert {
    position: relative;
    overflow: hidden;
    max-height: 400px;
  }
  .alert {
    background-color: $brandSalmon;
    color: white;
    max-width: 800px;
    margin: 10px auto;
    padding: 10px 20px;
    position: relative;
    overflow: hidden;
    max-height: 400px;
    a {
      color: white;
      &:hover {
        text-decoration: none;
      }
    }
    &.message {
      background-color: $brandBrightGreen;
    }
  }
  .alertMessage {
    font-weight: bold;

  }
  .closeAlert {
    display: block;
    margin: auto;
    border: none;
    color: white;
    background: none;
    font-size: 1.2rem;
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/elements/Alert.vue